import React, { useState } from "react";
import Slider from "react-slick";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { FaPlay } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slidshow = () => {
  const images = [
    "https://picsum.photos/id/1015/800/400",
    "https://picsum.photos/id/1016/800/400",
    "https://picsum.photos/id/1018/800/400",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [showPreview, setShowPreview] = useState(false);

  // Custom arrows for slick
  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-2 top-1/2 -translate-y-1/2  bg-opacity-50 text-3xl hover:bg-opacity-70 text-white rounded-full p-2 z-20"
      aria-label="Next"
      type="button"
    >
      <MdKeyboardArrowRight />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-2 top-1/2 -translate-y-1/2 bg-opacity-50 text-3xl hover:bg-opacity-70 text-white rounded-full p-2 z-20"
      aria-label="Previous"
      type="button"
    >
      <MdKeyboardArrowLeft />
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),

    // Dots inside image area at bottom
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: 16,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          zIndex: 20,
          
          pointerEvents: "none", // disable container pointer events to avoid interfering with buttons
        }}
      >
        <ul style={{ margin: 0, padding: 0, display: "flex", gap:1, pointerEvents: "auto" }}>
          {dots}
        </ul>
      </div>
    ),

   customPaging: (i) => (
  <button
    style={{
      width: 2,          // smaller dot width
      height: 2,         // smaller dot height
      borderRadius: "50%", // better to use 50% for perfect circle
      backgroundColor: "rgba(255,255,255,0.7)",
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s",
      
    }}
    aria-label={`Go to slide ${i + 1}`}
  />
),

  };

  return (
    <div className="w-full max-w-[783px] mx-auto select-none relative group" style={{ position: "relative" }}>
      <Slider {...settings}>
        {images.map((src, idx) => (
          <div key={idx} className="relative" style={{ height: 272 }}>
            <div
              style={{
                height: 272,
                backgroundImage: `url(${src})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />

            {/* Black Overlay with hover dimming */}
            <div className="absolute inset-0 bg-black opacity-70 group-hover:opacity-90 transition-opacity duration-300 z-0"></div>

            {/* Caption with dimmed background on hover */}
            <div className="absolute inset-0 flex justify-center items-center px-4 text-center z-10">
              <div className="bg-transparent  transition-colors duration-300 p-4 rounded">
                <div className="text-white text-lg font-semibold transition duration-300 group-hover:brightness-[0.4]">
                  {idx === 0 && (
                    <>
                      <h1 className="text-white font-semibold text-xl mb-2">
                        Buyer Lis<span className="text-red-600">ting Service</span>
                      </h1>
                      <div className="w-[45%] ms-48 text-sm mx-auto">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          Laborum inventore, architecto distinctio explicabo...
                        </p>
                      </div>
                      <div className="flex justify-center">
                        <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 mt-1 cursor-pointer">
                          click Here
                        </h3>
                      </div>
                    </>
                  )}
                  {idx === 1 && (
                    <>
                      <h1 className="text-white font-semibold text-xl mb-2">
                        Seller Lis<span className="text-red-600">ting Service</span>
                      </h1>
                      <div className="w-[45%] ms-48 text-sm mx-auto">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          Laborum inventore, architecto distinctio explicabo...
                        </p>
                      </div>
                      <div className="flex justify-center">
                        <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 mt-1 cursor-pointer">
                          click Here
                        </h3>
                      </div>
                    </>
                  )}
                  {idx === 2 && (
                    <>
                      <h1 className="text-white font-semibold mb-2 w-[35%] ms-60 mx-auto">
                        Experience the Pow
                        <span className="text-red-600">er of Zero Middle Man</span>
                      </h1>
                      <div className="w-[45%] ms-48 text-sm mx-auto">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          Laborum inventore, architecto distinctio explicabo...
                        </p>
                      </div>
                      <div className="flex justify-center mt-1">
                        <h3 className="border-2 border-red-600 w-fit px-2 text-red-600 cursor-pointer">
                          click Here
                        </h3>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Preview Button */}
            {currentSlide === idx && (
              <div className="absolute inset-0 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                <button
                  className="text-sm bg-blue-700 bg-opacity-70 hover:bg-opacity-90 hover:brightness-110 flex mt-1 text-white px-4 py-1 rounded transition duration-300"
                  onClick={() => setShowPreview(true)}
                >
                  <FaPlay className="mt-0.5" />
                  <h1 className="ms-2">Preview</h1>
                </button>
              </div>
            )}
          </div>
        ))}
      </Slider>

      {/* Caption Below Banner */}
      <div className="mt-6 flex justify-center text-xl font-semibold">
        <h1 className="text-gray-700">Edit Your Banner Below Here</h1>
      </div>

      {/* Preview Modal */}
   {showPreview && (
  <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 overflow-auto p-4">
    <div className="relative w-full max-w-4xl md:ms-40  h-[272px] bg-black rounded-md flex justify-center items-center">
      
      {/* Hello text above the image */}
      <div className="absolute top-4 -translate-y-12 left-4 text-white text-lg ms-[35%] z-20">
       Just click and See your Banner
      </div>

      <img
        src={images[currentSlide]}
        alt="preview"
        className="w-full h-[272px] object-cover rounded-md opacity-25"
      />

      {/* Caption overlay */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-white px-6 text-center bg-black bg-opacity-30 rounded-md">
        {currentSlide === 0 && (
          <>
            <h1 className="text-2xl font-semibold mb-2">
              Buyer Lis<span className="text-red-600">ting Service</span>
            </h1>
            <p className="max-w-[70%] mx-auto text-sm">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Laborum inventore, architecto distinctio explicabo...
            </p>
            <div className="mt-4 inline-block border-2 border-red-600 px-4 py-1 text-red-600 cursor-pointer rounded">
              Click Here
            </div>
          </>
        )}
        {currentSlide === 1 && (
          <>
            <h1 className="text-2xl font-semibold mb-2">
              Seller Lis<span className="text-red-600">ting Service</span>
            </h1>
            <p className="max-w-[70%] mx-auto text-sm">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Laborum inventore, architecto distinctio explicabo...
            </p>
            <div className="mt-4 inline-block border-2 border-red-600 px-4 py-1 text-red-600 cursor-pointer rounded">
              Click Here
            </div>
          </>
        )}
        {currentSlide === 2 && (
          <>
            <h1 className="text-2xl font-semibold mb-2">
              Experience the Pow
              <span className="text-red-600">er of Zero Middle Man</span>
            </h1>
            <p className="max-w-[70%] mx-auto text-sm">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Laborum inventore, architecto distinctio explicabo...
            </p>
            <div className="mt-4 inline-block border-2 border-red-600 px-4 py-1 text-red-600 cursor-pointer rounded">
              Click Here
            </div>
          </>
        )}
      </div>

      {/* Close button */}
      <button
        className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-red-600 transition"
        onClick={() => setShowPreview(false)}
        aria-label="Close Preview"
      >
        &times;
      </button>
    </div>
  </div>
)}



    </div>
  );
};

export default Slidshow;
